import { render, staticRenderFns } from "./user-tree.vue?vue&type=template&id=726a2b00"
import script from "./user-tree.vue?vue&type=script&lang=ts"
export * from "./user-tree.vue?vue&type=script&lang=ts"
import style0 from "./user-tree.vue?vue&type=style&index=0&id=726a2b00&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports